import React from "react";

const SVG = ({
    style = {},
    fill = "#000",
    width = "10px",
    height = "17px",
    className = "",
    viewBox = "0 0 24 24"
}) => (
        <svg
            width={height}
            style={style}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-icon ${className || ""}`}
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id="home-copy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
                <line x1="2.47619048" y1="12" x2="21.5238095" y2="12" id="Line-Copy" stroke={fill} stroke-width="3"></line>
                <line x1="2.47619048" y1="4" x2="21.5238095" y2="4" id="Line" stroke={fill} stroke-width="3"></line>
                <line x1="2.47619048" y1="20" x2="21.5238095" y2="20" id="Line-Copy-2" stroke={fill} stroke-width="3"></line>
            </g>
        </svg>
    );

export default SVG;
